import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { rightArrowCircle } from '../library/Svgs';
import Stickyfill from 'stickyfilljs';

class PRSingleSidebar extends Component {
  componentDidMount() {
    document.querySelector('.toggle-sidebar').addEventListener('click', (e) => {
      document.querySelector('.single-performance-report-group').classList.toggle('menu-open');
    });

    Stickyfill.add(document.querySelector('.aside-inner'));
  }

  render() {
    const { reports, match, disableScrollWatch } = this.props;
    const activeReportSlug = match.params.report_slug;
    const activeDocSlug = match.params.docSlug;
    const activeOrgSlug = match.params.orgSlug;
    const activeReport = reports.filter(x => x.slug === activeReportSlug)[0];

    return (
      <aside>
        <div className="aside-inner">
          <div className="aside-inner-inner">
            <a
              href="javascript:void(0);"
              className="toggle-sidebar"
              dangerouslySetInnerHTML={{ __html: rightArrowCircle }}
            />
            <ul className="scroll-view-aside-ul">
              {Object.keys(activeReport.reports).map((key) => {
                const active = activeDocSlug === activeReport.reports[key].slug;

                return (
                  <li
                    key={`${activeReportSlug}-${activeReport.reports[key].slug}`}
                    className={`${
                      activeReport.reports[key].slug === activeOrgSlug ? 'active' : ''
                    }`}
                  >
                    <Link
                      href={`/${activeReportSlug}/${activeReport.reports[key].slug}/${
                        activeReport.reports[key].children[0].slug
                      }`}
                      to={`/${activeReportSlug}/${activeReport.reports[key].slug}/${
                        activeReport.reports[key].children[0].slug
                      }`}
                      data-nice-title={activeReport.reports[key].title}
                      onClick={disableScrollWatch}
                    >
                      {activeReport.reports[key].title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </aside>

      // <aside>
      //   <div className="aside-inner">
      //     <div className="sidebar-inner">
      //       <a
      //         href="javascript:void(0);"
      //         className="toggle-sidebar"
      //         dangerouslySetInnerHTML={{ __html: blueArrow }}
      //       />
      //       {/* <Link href="/" to="/">
      //       Back to All
      //     </Link> */}
      //       <ul>
      //         {Object.keys(activeReport.reports).map((key) => {
      //           const active = activeDocSlug === activeReport.reports[key].slug;

      //           return (
      //             <li
      //               key={`${activeReportSlug}-${activeReport.reports[key].slug}`}
      //               className={`${activeReport.reports[key].slug === activeOrgSlug ? 'active' : ''}`}
      //             >
      //               <Link
      //                 href={`/${activeReportSlug}/${activeReport.reports[key].slug}/${
      //                   activeReport.reports[key].children[0].slug
      //                 }`}
      //                 to={`/${activeReportSlug}/${activeReport.reports[key].slug}/${
      //                   activeReport.reports[key].children[0].slug
      //                 }`}
      //                 data-nice-title={activeReport.reports[key].title}
      //               >
      //                 {activeReport.reports[key].title}
      //               </Link>
      //             </li>
      //           );
      //         })}
      //       </ul>
      //     </div>
      //   </div>
      // </aside>
    );
  }
}

PRSingleSidebar.propTypes = {
  reports: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  match: PropTypes.shape({}).isRequired,
};

export default PRSingleSidebar;
